export default __webpack_public_path__ + "static/media/Danielle_Meadows-Stinnett_AHV_In_Moms_We_Trust.00697323.jpg";